import type Hls from "hls.js";
import type { VideoVariant } from "src/store/api/generatedApi";

export const VIDEO_QUALITIES = [
  "original",
  "low",
] as const satisfies readonly VideoVariant[];

export const DEFAULT_VIDEO_QUALITY: VideoVariant = "low";

export const isVideoQuality = (value: unknown): value is VideoVariant =>
  VIDEO_QUALITIES.some((quality) => quality === value);

type QualityLevel = Pick<Hls["levels"][number], "name" | "width" | "height">;

export const levelIndexForQuality = (
  levels: readonly QualityLevel[],
  quality: VideoVariant
): number => levels.findIndex((level) => level.name === quality);

export const applyVideoQuality = (hls: Hls, quality: VideoVariant): void => {
  const index = levelIndexForQuality(hls.levels, quality);
  if (index < 0) return;
  if (hls.media && hls.media.buffered.length > 0) {
    if (hls.nextLoadLevel !== index || hls.loadLevel !== index)
      hls.nextLevel = index;
    return;
  }
  hls.startLevel = index;
  hls.loadLevel = index;
};

export const originalAspectRatio = (
  levels: readonly QualityLevel[]
): number | null => {
  const original = levels[levelIndexForQuality(levels, "original")];
  if (!original?.width || !original.height) return null;
  return original.width / original.height;
};
